/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description UserMessageTraits
 */

export enum UserMessageTraits {
  /** indicates message was sent as a phone call reminder */
  PARALLEL_LEAD = 1,
  /** indicates message was sent from a renter nudge prompt */
  NUDGE_FOLLOWUP = 2,
  /** indicates message was sent as part of a multimessage */
  MULTI_MESSAGE = 3,
  /** indicates message was sent with request to apply */
  APPLICATION_REQUEST = 4,
  /** indicates prospect messaging was recognized to be a power prospect */
  POWER_PROSPECT = 5,
  /** indicates message was a tour request */
  TOUR_REQUEST = 6,
  /** indicates message was for a waitlisted property */
  WAITLIST = 7,
  /** indicates message was for a premium filter ad property */
  FILTER_AD = 8,
  /** indicates message was for an engrain sitemap tour request */
  ENGRAIN_SITEMAP = 9,
  /** indicates message was sent as part of the digital lead concierge workflow: https://zumper.atlassian.net/wiki/spaces/EX/pages/1954152464/Digital+Lead+Concierge+a.k.a+DLC */
  DLC = 10,
  /** indicates message was sent from a resyndication partner */
  EXTERNAL = 11,
  /** indicates message was sent from a resyndication partner with the billable param */
  BILLABLE = 12,
  /** indicates message was sent from the resident quotes module */
  RESIDENT_QUOTE = 13,
  /** indicates message was sent from Zoe the chatbot */
  ZOE_CHATBOT = 14,
}

Object.defineProperty(UserMessageTraits, '__ENUM_NAME', {
  value: 'UserMessageTraits',
  writable: false,
  configurable: false,
  enumerable: false,
})
